<template>
    <div>
        <p v-if="registration.whelpingDateExplanation" class="red--text">
            <h4 v-if="registration.whelpingDateExplanation" class="blue-grey--text text--darken-1">Conflicting whelping date explanation:</h4>
            {{registration.whelpingDateExplanation}}
        </p>
        <p>
            <h4 class="blue-grey--text text--darken-1">Artificial Insemination?:</h4>
            {{registration.isArtificialInsemination ? 'Yes' : 'No'}}
        </p>
        <v-row>
            <v-col cols="12" sm="6">
                <h2 class="blue-grey--text text--darken-1">Dam:</h2>
                <v-row class="mt-5">
                    <v-col cols="1">
                        <v-img :src="defaultImage" class="profile-picture" min-width="40px" max-width="40px" contain />
                    </v-col>
                    <v-col cols="11">
                        <h3><b>{{registration.dam.name}}</b></h3>
                        <span>{{registration.dam.ascaId}} • {{registration.dam.mainColor}} • {{registration.dam.dnaStatus}}</span>
                    </v-col>
                </v-row>      
                <v-row>
                    <v-col cols="10">
                        <h4 class="blue-grey--text text--darken-1" v-if="registration.dam.leaseInfo">Leesses
                            &nbsp;(Lease: {{$dateUtils.formatDate(registration.dam.leaseInfo.startDate)}} - {{$dateUtils.formatDate(registration.dam.leaseInfo.endDate)}})
                        </h4>
                        <CoownersList :owners="registration.dam.owners" :ownershipType="dogOwnershipType" :hideHeader="registration.dam.leaseInfo"/>
                    </v-col>
                    <v-spacer/>
                </v-row>   
                <div class="mt-7" v-if="registration && registration.kennels.length > 0">                    
                    <h2 class="blue-grey--text text--darken-1">
                        Associated Kennels:
                    </h2>
                    <ul v-for="kennel in registration.kennels" v-bind:key="kennel.kennelId">
                        <li><b>{{kennel.kennelName}} </b></li>
                    </ul>
                </div>   
                <div class="mt-7" v-if="registration && registration.kennels.length == 0">                    
                    <h2 class="blue-grey--text text--darken-1">
                        No Associated Kennels
                    </h2>
                </div>  
            </v-col>
            <v-divider vertical light class="d-none d-sm-flex"></v-divider>
            <v-col cols="12" sm="6">
                <h2 class="blue-grey--text text--darken-1">Sires:</h2>
                <div v-for="sire in registration.sires" v-bind:key="sire.ascaId" class="mt-5">                       
                    <v-row>
                        <v-col cols="1">
                            <v-img :src="defaultImage" class="profile-picture mt-2" min-width="40px" max-width="40px" contain />
                        </v-col>
                        <v-col cols="11">
                            <h3><b>{{sire.name}}</b> </h3>
                            <span>{{sire.ascaId}} • {{sire.mainColor}} • {{sire.dnaStatus}}</span>
                        </v-col>
                    </v-row>    
                    <v-row>
                        <v-col cols="10">
                            <h4 class="blue-grey--text text--darken-1" v-if="sire.leaseInfo">Leesses
                                    &nbsp;(Lease: {{$dateUtils.formatDate(sire.leaseInfo.startDate)}} - {{$dateUtils.formatDate(sire.leaseInfo.endDate)}})
                            </h4>
                            <CoownersList :owners="sire.owners" :ownershipType="dogOwnershipType" :hideHeader="sire.leaseInfo"/>
                        </v-col>
                        <v-spacer/>
                    </v-row>   
                </div>
            </v-col>
        </v-row>
        <div>
            <h2 class="blue-grey--text text--darken-1 mt-5">Puppies</h2>
            <p>
                <v-simple-table fixed-header :height="(registration && registration.puppies) ? Math.min(250, (registration.puppies.length + 2) * 50) : 250">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">Sire ID</th>
                                <th class="text-left">Sex</th>
                                <th class="text-left">Main Color</th>
                                <th class="text-left">Dead/Culled?</th>
                                <th class="text-left">Breeder Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(puppy, index) in registration.puppies" :key="index">
                                <td>{{ puppy.sireId }}</td>
                                <td>{{ puppy.gender }}</td>    
                                <td>{{ puppy.mainColor }}</td>
                                <td :class="puppy.isDead ? 'red--text' : ''">{{ puppy.isDead ? 'Yes' : 'No'}}</td>
                                <td>{{ puppy.notes }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </p>
        </div>  
    </div>               
</template>

<script lang="ts">
import Vue from "vue";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";

const defaultImage = require('@/assets/photouploadblue.png');

export default Vue.extend({
  name: 'LitterRegistrationRequest',
  components: { 
    CoownersList     
  },
  props: {
    registration: { type: Object },
  },
  data: function () {
    return {
        defaultImage,
    };
  },
  computed: {
    dogOwnershipType: function() {
      return OwnershipType.Dog;
    },
  }
});
</script>